import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { declarationsAPI } from '../../services/api';
import Modal from '../../components/Modal';

const StudentDeclarations = () => {
  const { t } = useTranslation();
  const [templates, setTemplates] = useState([]);
  const [requests, setRequests] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ templateId: '', requestedData: {} });

  const selectedTemplate = templates.find((tpl) => tpl.id === form.templateId);

  const loadData = async () => {
    const [tpl, req] = await Promise.all([declarationsAPI.getTemplates(), declarationsAPI.getRequests()]);
    setTemplates((tpl.templates || []).filter((item) => item.type !== 'administrative'));
    setRequests((req.requests || []).filter((item) => item.template?.type !== 'administrative'));
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmitRequest = async (e) => {
    e.preventDefault();
    await declarationsAPI.createRequest({ templateId: form.templateId, requestedData: form.requestedData || {} });
    setForm({ templateId: '', requestedData: {} });
    setShowModal(false);
    await loadData();
  };

  const handleViewDocument = async (requestId) => {
    const blob = await declarationsAPI.getDocumentBlob(requestId, 'view');
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank', 'noopener,noreferrer');
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  };

  const handleDownloadDocument = async (requestId) => {
    const blob = await declarationsAPI.getDocumentBlob(requestId, 'download');
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `declaration_${requestId}.html`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="student-dashboard">
      <div className="dashboard-header">
        <h1>{t('declaration.title')}</h1>
        <button className="btn-primary" onClick={() => setShowModal(true)}>{t('common.add')}</button>
      </div>

      <div className="courses-list">
        {requests.map((req) => (
          <div key={req.id} className="course-card" style={{ display: 'block' }}>
            <h3>{req.template?.name}</h3>
            <p>{req.status}</p>
            {req.signedAt && <small>Signed: {new Date(req.signedAt).toLocaleDateString()}</small>}
            {req.generatedDocument && (
              <div className="form-actions" style={{ marginTop: '10px' }}>
                <button type="button" className="btn-primary" onClick={() => handleViewDocument(req.id)}>View</button>
                <button type="button" className="btn-secondary" onClick={() => handleDownloadDocument(req.id)}>Download</button>
              </div>
            )}
          </div>
        ))}
      </div>

      <Modal isOpen={showModal} onClose={() => setShowModal(false)} title={t('declaration.request')}>
        <form onSubmit={handleSubmitRequest} className="add-form">
          <select
            className="form-input"
            value={form.templateId}
            onChange={(e) => setForm((prev) => ({ ...prev, templateId: e.target.value, requestedData: {} }))}
            required
          >
            <option value="">{t('common.select')}</option>
            {templates.map((tpl) => (
              <option key={tpl.id} value={tpl.id}>{tpl.name}</option>
            ))}
          </select>
          {(selectedTemplate?.fields || []).map((field) => (
            <div key={field.key} className="form-group">
              <label>{field.label}</label>
              {field.type === 'date' ? (
                <input
                  type="date"
                  className="form-input"
                  value={form.requestedData?.[field.key] || ''}
                  onChange={(e) => setForm((prev) => ({
                    ...prev,
                    requestedData: { ...prev.requestedData, [field.key]: e.target.value }
                  }))}
                  required={field.required}
                />
              ) : field.type === 'select' ? (
                <select
                  className="form-input"
                  value={form.requestedData?.[field.key] || ''}
                  onChange={(e) => setForm((prev) => ({
                    ...prev,
                    requestedData: { ...prev.requestedData, [field.key]: e.target.value }
                  }))}
                  required={field.required}
                >
                  <option value="">{t('common.select')}</option>
                  {(field.options || []).map((option) => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
              ) : (
                <input
                  type={field.type === 'number' ? 'number' : 'text'}
                  className="form-input"
                  value={form.requestedData?.[field.key] || ''}
                  onChange={(e) => setForm((prev) => ({
                    ...prev,
                    requestedData: { ...prev.requestedData, [field.key]: e.target.value }
                  }))}
                  required={field.required}
                />
              )}
            </div>
          ))}
          <div className="form-actions">
            <button className="btn-primary" type="submit">{t('common.save')}</button>
            <button className="btn-secondary" type="button" onClick={() => setShowModal(false)}>{t('common.cancel')}</button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default StudentDeclarations;
